import { getFetch } from '../fetch';
import { apiConfig } from '../config';

/** Настоящий тип в modules с тем же названием */
type TeacherReserveAward = unknown;

export function getTeacherReserveAwards<T extends TeacherReserveAward>(): Promise<T> {
    const { apiGetTeacherReserveAwards } = apiConfig.getStaticUrls();

    return getFetch(apiGetTeacherReserveAwards);
}
